/* eslint-disable camelcase */
import FileSaver from 'file-saver';
import './teamLeadPayoutDetails.scss'
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';
//import { metricValueFormat } from '../../utils/metricValueFormat';
import { useGetScorecardAgentsQuery } from '../scoreCardFilter/scoreCardFilterSlice';
import { useGetTeamleadPayoutDetailsQuery } from './teamLeadPayoutDetailsSlice';


type teamLeadPayoutDetailsProps = {
    inputScorecardVersion: number;
    inputYear: number;
    inputMonth: number;
    inputRoleId: number;
};

// eslint-disable-next-line max-statements
export const TeamLeadPayoutDetails = ({
    inputYear,
    inputMonth,
    inputScorecardVersion,
    inputRoleId,
}: teamLeadPayoutDetailsProps) => {
    const [supervisorNumber, setSupervisorNumber] = useState();
    const [metricColHeaders, setMetricColHeaders] = useState<any>([]);
    const [teamleadPayoutDetails, setTeamleadPayoutDetails] = useState<any>();
    const [teamLeadsData, setTeamLeadsData] = useState<any>([]);

    const SupervisorOnChange = (e: any) => {
        setSupervisorNumber(e.value);
    };
    const { data: scorecardSupervisorsData } = useGetScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            scorecardRoleId: inputRoleId

        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion || !inputRoleId }
    );
    const { data: teamLeadPayoutDetailsData } = useGetTeamleadPayoutDetailsQuery({
        employeeNumber: supervisorNumber,
        month: inputMonth,
        year: inputYear,
        scorecardVersionId: inputScorecardVersion,
        scorecardRoleId: inputRoleId
    }, {
        skip: !inputMonth || !inputYear || !inputScorecardVersion || !supervisorNumber
    });
    useEffect(() => {
        setTeamLeadsData([]);
        if (scorecardSupervisorsData !== undefined && scorecardSupervisorsData?.data?.length > 0) {

            const teamLeads = [{ supervisor_number: '0', supervisor_name: 'All' }];
            scorecardSupervisorsData?.data.forEach((element: any) => {
                if (element.supervisor_number && !teamLeads.some(e => e.supervisor_number === element.supervisor_number)) {
                    teamLeads.push(element);
                }

            });
            setTeamLeadsData(teamLeads);
        }
    }, [scorecardSupervisorsData]);
    useEffect(() => {
        setMetricColHeaders(teamLeadPayoutDetailsData?.data[0]?.colHeaders?.split('$') || []);
    }, [supervisorNumber, inputYear, inputScorecardVersion, inputMonth, teamLeadsData, teamLeadPayoutDetailsData]);

    useEffect(() => {
        setTeamleadPayoutDetails(teamLeadPayoutDetailsData?.data?.length > 0 ? teamLeadPayoutDetailsData.data : [])
    }, [teamLeadPayoutDetailsData]);
    const exportExcel = (teamLeadPayoutDetails: any, metricColHeader: any) => {
        import('xlsx').then((xlsx: any) => {
            const worksheet = xlsx.utils.json_to_sheet(expPayoutCal(teamLeadPayoutDetails, metricColHeader));
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'TeamLead_Payout_Details');
        });
    };
    const saveAsExcelFile = (buffer: any, fileName: any) => {
        const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
            type: EXCEL_TYPE,
        });
        FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    };
    const expPayoutCal = (teamleadPayoutDetails: any[], metricColHeader: string[]) => {
    const expAge = [];

    for (let i = 0; i < teamleadPayoutDetails.length; i++) {
        const teamlead = teamleadPayoutDetails[i];

        const row: any = {
            Employee: `${teamlead.employee}`,
            Total_metrics_targeted: `${teamlead.total_metrics_targeted}`,
            Total_metrics_reported: `${teamlead.total_metrics_reported}`,
            Total_metrics_attained: `${teamlead.total_metrics_attained}`,
            Attainment_achieved: `${teamlead.attainment_achieved}`,
        };

        // Map ColValues to formatted metric column headers
        metricColHeader.forEach((header: string, index: number) => {
            const formattedKey = header.replaceAll(' - ', '_');
            const value = teamlead.colValues?.[index] ?? null;
            row[formattedKey] = value;
        });

        expAge.push(row);
    }

    return expAge;
};

    return (
        <div className="flex justify-content-between mb5">

            <Dropdown
                value={supervisorNumber}
                onChange={SupervisorOnChange}
                options={teamLeadsData}
                optionValue={'supervisor_number'}
                optionLabel={'supervisor_name'}
                placeholder={'Select Team Lead'}
                className="custom-dropdown m-4"
            />

            <div className="float-end">
                <Button
                    type="button"
                    icon="pi pi-upload me-2"
                    className="btn-export m-4"
                    onClick={() => exportExcel(teamleadPayoutDetails, metricColHeaders)}
                    data-pr-tooltip="XLS"
                >
                    Export to Excel
                </Button>
            </div>
            <div className="card datatable-doc-demo border-0 table">
                {metricColHeaders != null ? (
                    <DataTable
                        value={teamleadPayoutDetails}
                        className="mainTable"
                        rows={5}
                        paginator={teamleadPayoutDetails?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    >
                        <Column
                            header="Employee"
                            field="employee"
                            sortable
                            sortField="employee"
                        />
                        <Column
                            header="Total Metrics Targeted"
                            field="total_metrics_targeted"
                            sortable
                            sortField="total_metrics_targeted"
                        />
                        <Column
                            header="Total Metrics Reported"
                            field="total_metrics_reported"
                            sortable
                            sortField="total_metrics_reported"
                        />
                        <Column
                            header="Total Metrics Attained"
                            field="total_metrics_attained"
                            sortable
                            sortField="total_metrics_attained"
                        />
                        <Column
                            header="Attainment Achieved"
                            field="attainment_achieved"
                            sortable
                            sortField="attainment_achieved"
                        />

                        {/* Dynamically generate columns based on metricColHeaders */}
                        {metricColHeaders?.map((header:any, index:number) => (
                            <Column
                                key={index}
                                header={header}
                                body={(rowData: any) => rowData.colValues?.[index] ?? "--"}
                            />
                        ))}
                    </DataTable>

                ) : (
                    <DataTable
                        value={teamleadPayoutDetails}
                        className="mainTable teamLeadPayoutDetails"
                        rows={5}
                        paginator={teamleadPayoutDetails?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    />
                )}
            </div>
        </div>

    );
};
